import React from 'react'
import { authRoles } from '../../auth/authRoles'

const AptituteRoutes = [

    {
        path: '/aptitutetest/all',
        component: React.lazy(() => import('./AllTest')),
        auth: authRoles.aptituteTestView,
    },
    {
        path: '/aptitutetest/create',
        component: React.lazy(() => import('./Create')),
        auth: authRoles.aptituteTestCreate,
    },

]

export default AptituteRoutes
